import { useEffect, useState } from "react";
import { Modal } from "antd";
import Confetti from "react-confetti";
import { useWindowSize } from "@react-hook/window-size";
import { markAchievementsAsSeen } from "../../apis/achievementsApi"; // <-- Import your API function
import "./AchievementModal.css";

const AchievementAnimation = ({ animations = [], onClose: parentOnClose }) => {
  const [current, setCurrent] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [confettiRecycle, setConfettiRecycle] = useState(false);
  const [width, height] = useWindowSize();

  useEffect(() => {
    if (animations.length > 0) {
      setShowConfetti(true);
      setConfettiRecycle(true);
    }
  }, [animations]);

  // Confetti timing
  useEffect(() => {
    if (showConfetti) {
      const stopRecycle = setTimeout(() => setConfettiRecycle(false), 2000);
      const hideConfetti = setTimeout(() => setShowConfetti(false), 6000);
      return () => {
        clearTimeout(stopRecycle);
        clearTimeout(hideConfetti);
      };
    }
  }, [showConfetti]);

  const handleNext = () => {
    if (current < animations.length - 1) {
      setCurrent(current + 1);
      setShowConfetti(true);
      setConfettiRecycle(true);
    } else {
      handleClose();
    }
  };

  // Custom onClose handler
  const handleClose = async () => {
    try {
      // Get user_id from the first animation (assuming all are for the same user)
      const user_id = animations[0]?.user_id;
      const animation_ids = animations.map(a => a.animation_id);

      await markAchievementsAsSeen({ user_id, animation_ids });
    } catch (error) {
      console.error("Error marking achievements as seen:", error);
    }
    if (parentOnClose) parentOnClose(); // To clean parent animations array
  };

  const achievement = animations[current];

  return (
    <>
      <Modal
        open={!!achievement}
        footer={null}
        centered
        closable={false}
        onCancel={handleClose}
        afterClose={handleClose}
      >
        {achievement && (
          <div className="text-center">
            <h4>Logro Desbloqueado!</h4>
            <p>{achievement.name}</p>
            <div key={current} className="achievement-image-container">
              <img className="image-grey" src={`/img/achievements/${achievement.locked_img}`} alt="locked_img"/>
              <img className="image-color fade-in" src={`/img/achievements/${achievement.unlocked_img}`} alt="unlocked_img"/>
            </div>
            <button className="btn btn-primary mt-3" onClick={handleNext}>
              {current < animations.length - 1 ? "Siguiente" : "Cerrar"}
            </button>
          </div>
        )}
      </Modal>
      {showConfetti && (
        <Confetti
          width={width}
          height={height}
          recycle={confettiRecycle}
          style={{ zIndex: 2000, position: "fixed", top: 0, left: 0 }}
        />
      )}
    </>
  );
};

export default AchievementAnimation;
